import { useState, useEffect } from "react";
import { useTheme } from "../context/ThemeContext";
import LoginForm from "../components/Login";
import RegisterForm from "../components/RegisterForm";
import TermsConditions from "../components/TermsConditions";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPrint, FaQuoteLeft, FaRegLightbulb, FaPalette, FaAward } from "react-icons/fa";

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const { darkMode } = useTheme();
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  const loginMessage = location.state?.message || "";

  useEffect(() => {
    if (loginMessage && location.key) {
      toast.warn(loginMessage, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: darkMode ? "dark" : "light",
      });
    }
  }, [loginMessage, darkMode]);

  return (
    <div
      className={`flex flex-col md:flex-row h-screen w-full transition-colors duration-500 ${
        darkMode ? "bg-gray-950 text-white" : "bg-gray-100 text-gray-900"
      }`}
    >
      {/* Branding Section (Left Side) */}
      <div className="hidden md:flex flex-col items-center justify-center w-1/2 p-12 space-y-8">
        <div className="text-center flex flex-col items-center">
          <div className="flex items-center mb-4">
            <FaPrint className="text-4xl mr-3 text-blue-500" />
            <h1 className="text-5xl font-extrabold tracking-wide">PrintKaro.shop</h1>
          </div>
          <p className="text-lg italic text-gray-400 flex items-center">
            <span className="mr-1">~</span> By JBSM Enterprises
          </p>
        </div>

        <div className="max-w-md">
          <div className="grid grid-cols-2 gap-6">
            {/* First Row */}
            <div className="flex items-start">
              <FaQuoteLeft
                className={`text-xl mr-3 mt-1 ${darkMode ? "text-blue-400" : "text-blue-600"}`}
              />
              <blockquote
                className={`text-xl italic ${darkMode ? "text-gray-300" : "text-gray-700"}`}
              >
                "Your vision, perfectly printed"
              </blockquote>
            </div>

            <div className="flex items-start">
              <FaPalette
                className={`text-xl mr-3 mt-1 ${darkMode ? "text-blue-400" : "text-blue-600"}`}
              />
              <blockquote
                className={`text-xl italic ${darkMode ? "text-gray-300" : "text-gray-700"}`}
              >
                "Vibrant colors, crisp details"
              </blockquote>
            </div>

            {/* Second Row */}
            <div className="flex items-start">
              <FaAward
                className={`text-xl mr-3 mt-1 ${darkMode ? "text-blue-400" : "text-blue-600"}`}
              />
              <blockquote
                className={`text-xl italic ${darkMode ? "text-gray-300" : "text-gray-700"}`}
              >
                "Award-winning print quality"
              </blockquote>
            </div>

            <div className="flex items-start">
              <FaRegLightbulb
                className={`text-xl mr-3 mt-1 ${darkMode ? "text-blue-400" : "text-blue-600"}`}
              />
              <blockquote
                className={`text-xl italic ${darkMode ? "text-gray-300" : "text-gray-700"}`}
              >
                "Bringing your ideas to life"
              </blockquote>
            </div>
          </div>
        </div>
      </div>

      {/* Authentication Form Section (Right Side) */}
      <div className="flex items-center justify-center w-full md:w-1/2 p-3">
        <div
          className={`rounded-xl shadow-lg w-full max-w-md transform transition-all duration-500 ${
            darkMode
              ? "bg-gray-800 text-white shadow-gray-700"
              : "bg-white text-gray-900 shadow-gray-300"
          }`}
        >
          {isLogin ? (
            <LoginForm setShowPopup={setShowPopup} toggleForm={() => setIsLogin(false)} />
          ) : (
            <RegisterForm setShowPopup={setShowPopup} toggleForm={() => setIsLogin(true)} />
          )}
        </div>
      </div>

      {/* Terms & Conditions Popup */}
      {showPopup && <TermsConditions onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default AuthPage;
